module.exports = __webpack_public_path__ + "assets/img/Exchange_tit.f8aa78bc.png";